<template>
  <el-container>
    <el-main class="main-sreach" :style="sreachNote">
      <div :v-intro="$t('home.searchHint')" data-disable-interaction=false v-intro-step="4" style="margin-top:20%">
        <div class="sub-title" style="color:#C0C4CC;font-size:14px;font-family:Helvetica Neue">{{$t('home.searchTypeHint')}}</div>
        <el-input :placeholder="$t('home.pleaseInput')" v-model="input3" class="input-with-select sreachInput">
          <el-select v-model="select1" slot="prepend" :placeholder="$t('home.choose')" style="width:100px">
            <el-option :label="$t('home.apartmentRoom')" value="1"></el-option>
            <el-option :label="$t('home.roomTenant')" value="2"></el-option>
          </el-select>
          <el-button slot="append" icon="el-icon-search" @click="onSelect"></el-button>
        </el-input>
      </div>
    </el-main>

    <el-footer>
      <div class="main-footer">
        <el-button-group style="min-width:700px;display:flex;justify-content:center;align-items:center;">
          <el-button style="width:160px;height:160px" @click="lockLowBattery">{{$t('home.lockLowBattery')}}{{this.lockStatistics.lowPower}}</el-button>
          <el-button style="width:160px;height:160px" @click="lockOnline">{{$t('home.lockOnline')}}:{{this.lockStatistics.online}}</el-button>
          <el-button style="width:160px;height:160px" @click="lockOffline">{{$t('home.lockOffline')}}{{this.lockStatistics.offline}}</el-button>
          <!-- <el-button style="width:110px;height:130px">已出租:0</el-button> -->
          <el-button style="width:160px;height:160px" @click="noRent">{{$t('home.onshow')}}{{this.lockStatistics.noRent}}</el-button>
          <!-- <el-button style="width:160px;height:160px" @click="noRent">门锁信号弱:100</el-button> -->
          <!-- <el-button style="width:160px;height:160px" @click="rentOutDate">{{$t('home.rentOutDate')}}{{this.lockStatistics.expire}}</el-button> -->
        </el-button-group>
      </div>
    </el-footer>
  </el-container>
</template>

<script>
export default {
  name: "home",
  data() {
    return {
      input3: "",
      select1: "1",
      sreachNote: {
        backgroundImage: "url(" + require("../assets/home.png") + ")",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover"
      },
      lockStatistics:{
        lowPower:0,
        offline:0,
        online:0,
        noRent:0,
        expire:0
      }
    };
  },
  created() {
    this.getLockStatistics();
    this.getRoomCheckInStatistics();
  },
  methods: {
    // rentOutDate(){
    //   this.$router.push({path:'/roomStaList',query: {status:4}});
    // },
    noRent(){
      this.$router.push({path:'/tenantList',query: {status:0}});
    },
    lockOffline(){
      this.$router.push({path:'/deviceList',query: {isOnline:0,activeName:"lockList"}});
    },
    lockOnline(){
      this.$router.push({path:'/deviceList',query: {isOnline:1,activeName:"lockList"}});
    },
    lockLowBattery(){
      this.$router.push({path:'/deviceList',query: {batteryLow:1,activeName:"lockList"}});
    },
    onSelect(){
      var selectType=this.select1;
      var inputContent=this.input3;
      if(inputContent=="" || inputContent==null){
          this.$message({
            message:this.$t('home.pleaseInput'),
            type: "warning"
          });
          return false;
      }
       switch(selectType){
         case "1":
           this.$router.push({path:'/roomList',query: {roomName:inputContent}});
           break;
         case "2":
           this.$router.push({path:'/tenantTabs',query: {tenantName:inputContent}});
           break;  
       }
    },
    getLockStatistics(){
       var formData = new FormData();
       this.$server
        .exam("/customer/dashboard/getLockStatistics", formData)
        .then(data => {
          if (data.code == 200) {
             var data=data.data;
             console.log(JSON.stringify(data));
             for(var str in data){
              switch(data[str].name){
              case this.$t('home.lowBattery'):
                 this.lockStatistics.lowPower=data[str].count;
               break;
              case this.$t('home.offline'): 
               this.lockStatistics.offline=data[str].count;
               break;
              case this.$t('home.online'):
                this.lockStatistics.online=data[str].count;
                 break;
             }
            }
           
          } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
          }
        });
    },
    getRoomCheckInStatistics(){
       var formData = new FormData();
       this.$server
        .exam("/customer/dashboard/getRoomCheckInStatistics", formData)
        .then(data => {
          if (data.code == 200) {
            var data=data.data;
             for(var str in data){
              switch(data[str].name){
              case this.$t('home.onshowTxt'):
                 this.lockStatistics.noRent=data[str].count;
               break;
              case this.$t('home.pastDate'): 
               this.lockStatistics.expire=data[str].count;
               break;
             }
            }
           
          } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
          }
        });
    },  
  }  
};
</script>
<style scoped>
.main-sreach {
  width: 100%;
  height: 350px;
  display: flex;
  justify-content: center;
  align-items: center;
  
}
.sreachInput {
  width:60vh;
  /* margin-top: 200px; */
}
.main-footer {
  width: 100%;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/components/home.vue